import { useEffect, useState } from 'react'
import jitterTime from 'jitter-time'
import {
  useRegisterManager,
  useTrainingModeManager,
} from '../../ng-compat/hooks'
import { useIsOffline } from '../shared/useIsOffline'

export const useRegisterOpenReminderNeeded = () => {
  const registerManager = useRegisterManager()
  const trainingModeManager = useTrainingModeManager()
  const { isOffline } = useIsOffline()

  const [trainingModeEnabled, setTrainingModeEnabled] = useState(
    trainingModeManager.trainingModeEnabled
  )
  const [needed, setNeeded] = useState(
    registerManager.isRegisterOpenReminderNeeded()
  )

  useEffect(() => {
    const setEnabled = () =>
      setTrainingModeEnabled(trainingModeManager.trainingModeEnabled)

    trainingModeManager.on('trainingModeEnabledChange', setEnabled)

    return () => {
      trainingModeManager.off('trainingModeEnabledChange', setEnabled)
    }
  }, [trainingModeManager])

  useEffect(() => {
    if (isOffline || trainingModeEnabled) {
      setNeeded(false)
      return
    }

    const checkIfNeeded = () =>
      setNeeded(registerManager.isRegisterOpenReminderNeeded())

    checkIfNeeded()

    registerManager.on('registerIdChange', checkIfNeeded)
    registerManager.on('closeRegisterReminderSeen', checkIfNeeded)

    const interval = setInterval(checkIfNeeded, jitterTime(5))
    return () => {
      clearInterval(interval)
      registerManager.off('registerIdChange', checkIfNeeded)
      registerManager.off('closeRegisterReminderSeen', checkIfNeeded)
    }
  }, [isOffline, trainingModeEnabled, registerManager])

  return needed
}
